import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center text-background-50 text-lg">
                <i className="ri-alert-fill"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">看料避雷社</span>
            </div>
            <p className="text-sm leading-relaxed text-background-200/90 font-body">
              把消费场景里反复出现的坑点，整理成可执行的避雷清单。入手之前先看一遍，少走弯路，少花冤枉钱。
            </p>
            <a
              href="mailto:contact@kanliaobilei.com"
              rel="nofollow"
              className="mt-4 inline-flex items-center gap-2 text-sm text-primary-200 hover:text-primary-100 font-label"
            >
              <i className="ri-mail-line"></i>
              contact@kanliaobilei.com
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4 flex items-center gap-2">
              <a href="/#categories" className="hover:text-primary-200">避雷分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/guides?category=${cat.id}`}
                    className="text-sm text-background-200/90 hover:text-primary-200 font-label"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4 flex items-center gap-2">
              <a href="/#guides" className="hover:text-primary-200">站内导航</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-200/90 hover:text-primary-200 font-label">首页</Link></li>
              <li><Link to="/guides" className="text-sm text-background-200/90 hover:text-primary-200 font-label">全部避雷清单</Link></li>
              <li><Link to="/faq" className="text-sm text-background-200/90 hover:text-primary-200 font-label">常见问题</Link></li>
              <li><Link to="/about" className="text-sm text-background-200/90 hover:text-primary-200 font-label">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50 mb-4 flex items-center gap-2">
              <a href="/#subscribe" className="hover:text-primary-200">订阅避雷提醒</a>
            </h4>
            <p className="text-sm text-background-200/90 font-body mb-4">
              新清单发布时收到一封简短提醒，只发有用的，随时可退订。
            </p>
            <Link
              to="/#subscribe"
              className="inline-flex items-center gap-2 rounded-md bg-secondary-500 px-4 py-2 text-sm text-background-50 hover:bg-secondary-600 transition-colors font-label whitespace-nowrap"
            >
              <i className="ri-notification-3-line"></i>
              去订阅
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-100/20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300/80 font-label">
            © {year} 看料避雷社 · 内容仅供参考，具体以平台规则与合同条款为准
          </p>
          <p className="text-xs text-background-300/80 font-label flex items-center gap-2">
            <i className="ri-information-line"></i>
            我们不针对任何具体商家，只讲通用套路
          </p>
        </div>
      </div>
    </footer>
  );
}